module.exports = __webpack_public_path__ + "img/login-3.25bca2e1.jpg";